import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../UserContext';
import logo from '../assets/images/logo_old.png';
import styles from './Login.module.css';
import styles_content from "./css/main-content.module.css";
import { toast } from 'react-toastify';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const fetchUsuarioData = async (token) => {
    try {
      const response = await fetch(`${BASE_URL}/hello-sol/usuarios/consulta?cpfCnpj=${username}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const usuarioData = await response.json();
        localStorage.setItem('userData', JSON.stringify(usuarioData));
        if (usuarioData.primeiroAcesso) {
          navigate(`/alterar-senha-primeiro-acesso/${usuarioData.id}`);
        } else {
          navigate('/home');
        }
      } else {
        setError('Erro ao buscar dados do usuário');
      }
    } catch (error) {
      console.error('Erro ao fazer a requisição:', error);
      setError('Erro ao fazer a requisição');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${BASE_URL}/hello-sol/auth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          login: username,
          senha: password,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('token', data.token);
        await fetchUsuarioData(data.token);
        setError('');
      } else {
        setError('Credenciais inválidas');
      }
    } catch (error) {
      console.error('Erro ao fazer a requisição:', error);
      setError('Sistema indisponível no momento.');
    }
  };

  // dentro do componente Login
  useEffect(() => {
    const sessaoExpirada = localStorage.getItem('sessaoExpirada');
    if (sessaoExpirada) {
      toast.error('Sessão expirada. Faça login novamente.', {
        position: 'top-right',
        autoClose: 8000,
        theme: 'colored'
      });
      localStorage.removeItem('sessaoExpirada');
    }
  }, []);


  return (
      <div className={styles.loginContainer}>
        <div className={styles.loginContent}>
          <div className={styles.loginLogoContainer}>
            <a href="/">
              <img src={logo} alt="Hello Sol" />
            </a>
          </div>
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleSubmit}>
            <div>
              <input
                  type="text"
                  value={username}
                  onChange={handleUsernameChange}
                  placeholder="CPF/CNPJ"
                  maxLength="14"
              />
            </div>
            <div>
              <input
                  type="password"
                  value={password}
                  onChange={handlePasswordChange}
                  placeholder="SENHA"
                  maxLength="30"
              />
            </div>
            <button type="submit" className={styles_content.buttonGroup}>
              Login
            </button>
          </form>
          <a href="/recuperar-senha" className={styles.forgotPasswordLink}>
            Esqueceu a senha?
          </a>
        </div>
      </div>
  );
}

export default Login;